import React from 'react';
import PropTypes from 'prop-types';

import { classNameWithModifiers as withMods } from 'helpers/class-name';
import Message from 'components/Message';
import StatusBox from 'components/StatusBox';
import ScheduleRecurrenceDays from '../../ScheduleRecurrenceDays';
import { DRAFT_STATUS, CANCELLED_STATUS } from '../../../Schedules.helpers';
import messages from '../../../Schedules.messages';

export const renderStatusBoxes = (status, isFuture) => {
  const statusMessages = [];

  if (status === DRAFT_STATUS) statusMessages.push(messages.board.row.statusDraft);
  if (status === CANCELLED_STATUS) statusMessages.push(messages.board.row.statusCancelled);
  if (!isFuture) statusMessages.push(messages.board.row.statusDatePassed);

  return statusMessages.map(message => (
    <Message as={StatusBox} key={message.id} className="schedules-list__status-tag" message={message} />
  ));
};

// A class-component parent won't did-mount/update until all class-component children did-mount/update.
// A class-component parent will did-mount/update before all function-component children useRef.
// This needs to be a class component to ensure refs are registered before the parent did-mount/update.
export default class ScheduleRow extends React.Component {
  static propTypes = {
    instanceId: PropTypes.number,
    instructorName: PropTypes.string,
    isFuture: PropTypes.bool,
    isSelected: PropTypes.bool,
    registerRef: PropTypes.func,
    schedule: PropTypes.shape({
      classTitle: PropTypes.string,
      durationInMinutes: PropTypes.number,
      recurrence: PropTypes.shape({ days: PropTypes.arrayOf(PropTypes.string) }),
      recurring: PropTypes.bool,
    }),
    setSelectedInstanceId: PropTypes.func,
    status: PropTypes.string,
    startingAt: PropTypes.instanceOf(Date),
  };

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount = () => {
    const { instanceId, registerRef } = this.props;
    registerRef(instanceId, this.ref.current);
  };

  render() {
    const {
      schedule: { classTitle, durationInMinutes, recurring, recurrence },
      setSelectedInstanceId,
      instructorName,
      isSelected,
      isFuture,
      status,
      startingAt,
    } = this.props;
    const disabledTextClassName = className =>
      withMods(className, { disabled: !isFuture || status === CANCELLED_STATUS });

    return (
      <button
        type="button"
        className="grid grid--flush grid--middle schedules-list__row"
        onClick={setSelectedInstanceId}
        data-cypress="schedules-list-row"
        ref={this.ref}>
        {isSelected && <span className="schedules-list__selected-marker" />}
        <div className="grid__item 1/9">
          <div className="schedules-list__cell">
            <div className={disabledTextClassName('schedules-list__text')}>
              <Message className="schedules-list__time" format="time" value={startingAt} />
            </div>
          </div>
        </div>
        <div className="grid__item 2/9">
          <div className="schedules-list__cell schedules-list__cell--extended">
            <div className={disabledTextClassName('schedules-list__text')}>{classTitle}</div>
            <Message
              as="div"
              className="schedules-list__text--gray"
              message={messages.board.row.duration}
              values={{ duration: durationInMinutes }}
            />
          </div>
        </div>
        <div className="grid__item 2/9">
          <div className="schedules-list__cell">
            <div className={disabledTextClassName('schedules-list__text')}>{instructorName || '-'}</div>
          </div>
        </div>
        <div className="grid__item 2/9">
          <div className="schedules-list__cell">
            <div className={disabledTextClassName('schedules-list__text schedules-list__text--gray')}>
              {recurring ? <ScheduleRecurrenceDays recurrence={recurrence} /> : <p>-</p>}
            </div>
          </div>
        </div>
        <div className="grid__item 2/9">
          <div className="schedules-list__cell schedules-list__cell--with-status">
            {renderStatusBoxes(status, isFuture)}
          </div>
        </div>
      </button>
    );
  }
}
